import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import Button from 'reactstrap/lib/Button';
import ModalBody from 'reactstrap/lib/ModalBody';
import Modal from 'reactstrap/lib/Modal';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { IMAGE_SIZES } from 'site-modules/shared/constants/editorial/editorial';
import { HeroCarousel } from 'site-modules/shared/components/hero-carousel/hero-carousel';

import './photoflipper-image-top-rated.scss';

export function PhotoflipperImageTopRated({ vehicleGallery = null, fullImageSize = 'lg' }) {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [isPhotoflipperOpen, setIsPhotoflipperOpen] = useState(false);

  const togglePhotoflipper = useCallback(
    index => {
      setIsPhotoflipperOpen(!isPhotoflipperOpen);
      setCurrentSlideIndex(index);
    },
    [isPhotoflipperOpen]
  );

  const carouselSlides =
    vehicleGallery &&
    vehicleGallery.map((slide, counter) => {
      const { href, title } = slide;
      const imageUri = getFullImageUrl(href, IMAGE_SIZES[fullImageSize]);
      return (
        <div key={title} className="slide" data-index={counter}>
          <img className="photo my-auto" alt={title} src={imageUri} />
        </div>
      );
    });

  return (
    <div className="pos-r photoflipper-image-container mb-0_25 rounded">
      <section className="thumbnails-container mx-auto pb-md-1">
        {vehicleGallery &&
          vehicleGallery.slice(0, 5).map((slide, index) => (
            <button
              className={classnames('thumbnail-photo pos-r d-block p-0', {
                'hidden-md-down': index > 0,
              })}
              key={`${slide.href}`}
              onClick={togglePhotoflipper.bind(this, index)}
            >
              <img src={getFullImageUrl(slide.href, 700)} alt={slide.title} className="w-100 h-100" />
              <span className="text-white fw-bold text-center hidden-md-up">View Gallery</span>
            </button>
          ))}
      </section>
      <Modal
        className="photoflipper-image-carousel-modal"
        isOpen={isPhotoflipperOpen}
        toggle={togglePhotoflipper}
        centered
        size="lg"
      >
        <ModalHeader tag="div" className="justify-content-end p-0" onClick={togglePhotoflipper}>
          <Button color="link" className="text-decoration-none p-0_25 heading-3 text-white">
            <i className="icon-cross2" aria-hidden />
          </Button>
        </ModalHeader>
        <ModalBody className="p-0">
          <HeroCarousel
            autoplay={false}
            lazyLoad
            className="editorial-hero-carousel"
            data-tracking-parent="edm-entry-editorial-hero-carousel"
            slides={carouselSlides}
            currentSlideIndex={currentSlideIndex}
          />
        </ModalBody>
      </Modal>
    </div>
  );
}

PhotoflipperImageTopRated.propTypes = {
  vehicleGallery: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      rel: PropTypes.string,
    })
  ),
  fullImageSize: PropTypes.string,
};
